module.exports = __webpack_public_path__ + "static/media/AQLogo.8c8ab130.png";